import React from 'react';
import { useHistory } from 'react-router';
import { MuiButton } from 'theme/material-ui';
import { useProviderSearch } from 'lib/hooks/ProviderSearch/useProviderSearch';
import ProviderSearchBar from 'screens/ProviderSearch/ProviderSearchBar';
import { providerSearch } from 'screens/ProviderSearch/utils';
import FlexBox from 'components/UI/Layout/FlexBox';
import { Spacing } from 'modules/styles/variables';
import { kyruusEnabled } from 'lib/findProvider/utils';
import { GetCareSearchContainer } from './styled';

function GetCareSearch() {
  const { change, search, query, suggestions, quickLinks } = useProviderSearch(false);
  const history = useHistory();

  return (
    <GetCareSearchContainer>
      {kyruusEnabled() ? (
        <FlexBox flexDirection="row" justifyContent="center" vSpacingTop={Spacing.xLargeLarge}>
          <MuiButton
            fullWidth
            color="primary"
            variant="outlined"
            onClick={() => {
              history.push('/u/find-a-doctor');
            }}
            data-testid="get-started-kyruus"
          >
            Get Started
          </MuiButton>
        </FlexBox>
      ) : (
        <ProviderSearchBar
          change={change}
          search={params => providerSearch({ from: 'Get Care', query, search, params })}
          value={query}
          suggestions={suggestions}
          quickLinks={quickLinks}
        />
      )}
    </GetCareSearchContainer>
  );
}

export default GetCareSearch;
